module.exports = __webpack_public_path__ + "img/bg-photo.ab4a7137.png";